<!--
  WishlistSheet:wish 场次详情弹窗内容。
  点击日历 wish cell 后展示;加入愿望单的真实 API 由父组件闭包注入。
-->
<template>
  <div
    class="wishlist-sheet"
    :class="`page-${pageType}`"
  >
    <h2 class="title">{{ t('Modal.wishlistTitle') }}</h2>

    <TicketPreviewCard
      class="ticket-preview"
      :page-type="pageType"
      :variant="variant"
      :rows="rows"
      :home-team="homeTeam"
      :away-team="awayTeam"
    />

    <div class="cta">
      <p
        v-if="!added"
        class="hint"
      >
        {{ t('Modal.wishlistHint') }}
      </p>
      <button
        type="button"
        class="wishlist-button"
        :class="{ added }"
        :disabled="added"
        @click="$emit('add')"
      >
        <span
          v-if="added"
          class="added-icon"
          aria-hidden="true"
        ></span>
        <span>{{ added ? t('Modal.wishlistAdded') : t('Modal.wishlistAdd') }}</span>
      </button>
    </div>

    <div
      v-if="showToast"
      class="wishlist-toast"
    >
      {{ t('Modal.wishlistToast') }}
    </div>

    <div
      v-if="pageType === 'H5'"
      class="home-indicator"
      aria-hidden="true"
    />
  </div>
</template>

<script lang="ts">
import TicketPreviewCard from './TicketPreviewCard.vue';
import t from '../utils/i18n';
type Row = {
  label: string;
  value: string;
};
type Props = {
  pageType: 'PC' | 'H5';
  variant: 'ticket' | 'concert';
  rows: Row[];
  homeTeam?: string;
  awayTeam?: string;
  added?: boolean;
  showToast?: boolean;
};
const __sfc_main = {};
__sfc_main.props = {
  pageType: {
    key: "pageType",
    required: true,
    type: String
  },
  variant: {
    key: "variant",
    required: true,
    type: String
  },
  rows: {
    key: "rows",
    required: true,
    type: Array
  },
  homeTeam: {
    key: "homeTeam",
    required: false,
    type: String,
    default: 'Mets'
  },
  awayTeam: {
    key: "awayTeam",
    required: false,
    type: String,
    default: 'Miami'
  },
  added: {
    key: "added",
    required: false,
    type: Boolean,
    default: false
  },
  showToast: {
    key: "showToast",
    required: false,
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  return {
    t
  };
};
__sfc_main.components = Object.assign({
  TicketPreviewCard
}, __sfc_main.components);
export default __sfc_main;
</script>

<style scoped>
.wishlist-sheet {
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.title {
  margin: 0;
  color: #262626;
  font-weight: 600;
  line-height: 1.1em;
  letter-spacing: -0.02em;
}

.ticket-preview {
  align-self: center;
}

.cta {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hint {
  margin: 0;
  color: #1d1d1d;
  font-weight: 400;
  text-align: center;
}

.wishlist-button {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: none;
  background: #ff6900;
  color: #ffffff;
  font-weight: 600;
  cursor: pointer;
}

.wishlist-button.added {
  background: #d7d7d7;
  cursor: default;
}

.added-icon {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  border-radius: 50%;
}

.added-icon::after {
  position: absolute;
  display: block;
  box-sizing: border-box;
  content: '';
  transform: rotate(45deg);
}

.wishlist-toast {
  position: absolute;
  left: 50%;
  z-index: 2;
  box-sizing: border-box;
  background: rgba(15, 17, 18, 0.9);
  color: #ffffff;
  font-weight: 400;
  line-height: 1.35em;
  text-align: center;
  transform: translateX(-50%);
}

/* H5:设计稿 100px = 1rem */
.page-H5.wishlist-sheet {
  gap: 0;
}

.page-H5 .title {
  padding: 0.26rem 0.4rem 0.12rem;
  font-size: 0.5rem;
}

.page-H5 .cta {
  gap: 0.24rem;
  padding: 0.26rem 0.4rem 0;
}

.page-H5 .hint {
  font-size: 0.24rem;
  line-height: 1.3em;
  white-space: nowrap;
}

.page-H5 .wishlist-button {
  width: 5rem;
  height: 0.9rem;
  border-radius: 0.8rem;
  gap: 0.16rem;
  font-size: 0.36rem;
  line-height: 1.2em;
}

.page-H5 .added-icon {
  width: 0.32rem;
  height: 0.32rem;
  border: 0.02rem solid #ffffff;
}

.page-H5 .added-icon::after {
  top: 0.05rem;
  left: 0.1rem;
  width: 0.08rem;
  height: 0.16rem;
  border-right: 0.02rem solid #ffffff;
  border-bottom: 0.02rem solid #ffffff;
}

.page-H5 .wishlist-toast {
  top: 1.88rem;
  width: 5.3rem;
  min-height: 0.88rem;
  padding: 0.16rem 0.24rem;
  border-radius: 0.12rem;
  font-size: 0.24rem;
}

.page-H5 .home-indicator {
  height: 0.65rem;
}

/* PC */
.page-PC.wishlist-sheet {
  gap: 20px;
}

.page-PC .title {
  font-size: 28px;
}

.page-PC .cta {
  gap: 16px;
}

.page-PC .hint {
  font-size: 16px;
  line-height: 1.3em;
  white-space: nowrap;
}

.page-PC .wishlist-button {
  width: 280px;
  height: 60px;
  border-radius: 60px;
  gap: 10px;
  font-size: 24px;
}

.page-PC .added-icon {
  width: 22px;
  height: 22px;
  border: 2px solid #ffffff;
}

.page-PC .added-icon::after {
  top: 3px;
  left: 7px;
  width: 6px;
  height: 11px;
  border-right: 2px solid #ffffff;
  border-bottom: 2px solid #ffffff;
}

.page-PC .wishlist-toast {
  top: 88px;
  width: 340px;
  min-height: 56px;
  padding: 10px 18px;
  border-radius: 8px;
  font-size: 16px;
}
</style>
